// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_41-0";